import { colors } from "@wrstudios/theme";
export var defaultRadius = 1610;
export var radiusOptions = {
  editable: true,
  minRadius: 322,
  strokeWeight: 2,
  strokeOpacity: 1,
  fillOpacity: 0.1,
  fillColor: colors.blue[300],
  strokeColor: colors.blue[300]
};